import React from 'react'

const Header = (props) => {
    const { Title, lastUpdated } = props
    return (
        <div className='w-full bg-[#17355D] md:p-12 p-6'>
            <div className='max-w-7xl mx-auto  text-white space-y-1'>
                <h2 className="md:text-4xl text-3xl font-bold font-['Myriad_Pro']">
                    {Title}
                </h2>

                {lastUpdated && (
                    <p className="text-base text-[#f5f5f5] font-light font-['Myriad_Pro']">
                        {lastUpdated}
                    </p>
                )}

            </div>
        </div>
    )
}

export default Header
